<template>
  <div class="card-area">
    <form novalidate class="md-layout" @submit.prevent="validateUser">
      <md-card class="md-layout-item md-size-50 md-small-size-100">
        <div class="md-title">Secure ID Verify</div>
        <div class="md-title">
          We may have had a problem
          <br />
          verifying you, in which case
          <br />
          we will have contacted you to
          <br />
          login here and update your
          <br />
          information.
        </div>
        <br/>
        <div class="md-title">Login with your SVID and PIN</div>

        <md-card-content>
          <md-field>
            <label>Your SVID code (emailed)</label>
            <md-input
              v-model="form.email"
              :disabled="sending"
            />
            <span class="md-error" v-if="!$v.form.email.required"
              >The email is required</span
            >
            <span class="md-error" v-else-if="!$v.form.email.email"
              >Invalid email</span
            >
          </md-field>
          <md-field>
            <label for="password">Your provided 4 digit PIN</label>
            <md-input
              type="password"
              name="password"
              id="password"
              autocomplete="password"
              v-model="form.password"
            />
            <span class="md-error" v-if="!$v.form.email.required"
              >The password is required</span
            >
            <span class="md-error" v-else-if="!$v.form.email.email"
              >required 4 digits.</span
            >
          </md-field>
        </md-card-content>

        <md-progress-bar md-mode="indeterminate" v-if="sending" />

        <md-card-actions>
          <md-button @click="goConfirm" class="md-primary">login</md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";

export default {
  name: "LoginSVID",
  props: {
    msg: String,
  },
  component: {},
  mixins: [validationMixin],
  data: () => ({
    form: {
      firstName: null,
      lastName: null,
      email: null,
      password: null,
    },
    userSaved: false,
    sending: false,
    lastUser: null,
    phoneNumber: null,
    selectedDate: null,
  }),
  validations: {
    form: {
      firstName: {
        required,
        minLength: minLength(3),
      },
      lastName: {
        required,
        minLength: minLength(3),
      },
      email: {
        required,
        email,
      },
    },
  },
  mounted() {
    this.form.firstName = this.$route.params.firstName;
    this.form.lastName = this.$route.params.lastName;
    this.selectedDate = this.$route.params.date;
    this.phoneNumber = this.$route.params.phoneNumber;
    console.log(this.phoneNumber);
  },
  methods: {
    goConfirm() {
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    clearForm() {
      this.$v.$reset();
      this.form.firstName = null;
      this.form.lastName = null;
    },
    saveUser() {
      this.sending = true;
    },
    validateUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveUser();
      }
    },
  },
};
</script>

<style lang="css" scoped>
/* .md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
.md-card-actions {
  flex-direction: column;
}
.md-card-actions .md-button {
  margin-top: 20px !important;
  padding: 10px;
}
.md-card {
  display: inline-block;
  padding: 20px;
}
.card-area {
  align-items: center;
  justify-content: center;
  background: #ddd;
}
.md-primary {
  background-color: green;
  color: white !important;
}
.md-layout-item.md-size-50 {
  min-width: 100%;
  max-width: 50%;
} */
</style>